import { render, staticRenderFns } from "./TaskbarSystemTray.vue?vue&type=template&id=e6135aee&scoped=true&"
import script from "./TaskbarSystemTray.vue?vue&type=script&lang=js&"
export * from "./TaskbarSystemTray.vue?vue&type=script&lang=js&"
import style0 from "./TaskbarSystemTray.vue?vue&type=style&index=0&id=e6135aee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6135aee",
  null
  
)

export default component.exports